import React from 'react'

const Loader = (): JSX.Element => (
  <div className="_w-full _d-flex _align-items-center _justify-content-center">
    <hot-loading data-testid="hot-loading" />
  </div>
)

export default React.memo(Loader)
